import React from 'react'
import PropTypes from 'prop-types'

const BASE_CLASSES = 'tw:inline-flex tw:items-center tw:whitespace-nowrap tw:shrink-0 tw:rounded! '
  + 'tw:px-1.5 tw:py-0.5 tw:text-xs tw:font-medium'

const VARIANTS = {
  neutral: 'tw:bg-gray-100 tw:text-gray-950',
  info: 'tw:bg-blue-100 tw:text-blue-700',
  warning: 'tw:bg-orange-100 tw:text-orange-700',
  success: 'tw:bg-green-100 tw:text-green-700'
}

const Chip = ({ children, variant, className }) =>
  <span className={`${BASE_CLASSES} ${VARIANTS[variant]} ${className}`.trim()}>{children}</span>

Chip.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['neutral', 'info', 'warning', 'success'])
}

Chip.defaultProps = {
  className: '',
  variant: 'neutral'
}

export default Chip
